export enum ANALYZE_ROUTE_KEYS {
  START = '',
  BROWSE = 'browse',
  VISUALIZE = 'visualize',
  EFFECTS = 'effects',
}

export const ANALYZE_ROOT_ROUTE = 'analyze';
export const ANALYZE_VISUALIZE_ROUTE = `${ANALYZE_ROOT_ROUTE}/${ANALYZE_ROUTE_KEYS.VISUALIZE}`;
export const ANALYZE_RESTORE_PARAM = 'restore-default';
